/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import uuid from 'uuid'
import { ALERTS_CONFIG, ALERTS, DEFAULT_ALERTS_TIME_IN_MILLISECONDS } from 'constants/alerts'
import { CreateLocal, Remove, RemoveAll, IState, CreateAlert } from 'redux-app/types/alerts'
import { getCurrentTexts } from 'redux-app/selectors/localization'
import { createModuleAction, createReducer } from 'redux-app/utils/reducer'
import { text } from 'redux-app/utils/localization'
import { getAlertTexts } from 'utils/error'

const createAction = createModuleAction('ALERTS')

const createLocal: CreateLocal = createAction('CREATE')
export const remove: Remove = createAction('REMOVE')
export const removeAll: RemoveAll = createAction('REMOVE_ALL')

export const onShowError = (error: any, sentValues?) => (dispatch, getState) => {
  if (error.status === 401) {
    return
  }
  const texts = getCurrentTexts(getState())
  dispatch(createAlert({
    name: ALERTS.error,
    ...getAlertTexts(error, text({ texts }), sentValues),
  }))
}

export const createAlert: CreateAlert = ({ name, messageParams, ...restProps }) => (dispatch, getState) => {
  const t = text({ texts: getCurrentTexts(getState()), startPath: `alerts.${name}` })
  const alertTexts = {
    headline: t('headline') || 'Headline',
    message: t('message', messageParams) || 'Message text',
  }
  const id = uuid()
  const alert = {
    id,
    ...alertTexts,
    timeout: DEFAULT_ALERTS_TIME_IN_MILLISECONDS,
    ...ALERTS_CONFIG[name],
    name,
    ...restProps,
  }
  dispatch(createLocal(alert))
  return id
}

const ACTION_HANDLERS = {
  [createLocal.toString()]: (state, { payload }) => ({
    ...state,
    items: [
      ...state.items,
      {
        id: payload.id,
        ...payload,
      },
    ],
  }),
  [remove.toString()]: (state, { payload: { id } }) => ({
    ...state,
    items: state.items.filter(item => item.id !== id),
  }),
  [removeAll.toString()]: state => ({
    ...state,
    items: [],
  }),
}

const initialState: IState = {
  items: [],
}

export default createReducer(initialState, ACTION_HANDLERS)
